import React from "react";
import "./App.css";
import AppLayout from "./site/components/AppLayout/AppLayout";
import { BrowserRouter } from "react-router-dom";
import { themeSettings } from "./site/configuration/themeSettings";
import { AppSystemProvider } from "./site/components/AppSystem/AppSystem";
import { AppParamsProvider } from "./site/components/AppParamsProvider/AppParamsProvider";
import { AppContextProvider } from "./site/components/AppContextProvider/AppContextProvider";
import { ThemeProvider } from "@mui/material";
import { AppAuthentication } from "./site/configuration/componentsConfig";
import AppErrorHandling from "./site/components/AppErrorBoundary/AppErrorHandling";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ThemeProvider theme={themeSettings.main}>
        <AppAuthentication>
          <AppErrorHandling>
            <AppSystemProvider>
              <AppParamsProvider>
                <AppContextProvider>
                  <AppLayout></AppLayout>
                </AppContextProvider>
              </AppParamsProvider>
            </AppSystemProvider>
          </AppErrorHandling>
        </AppAuthentication>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
